import styled from "styled-components"

import { LIGHT_GREY, DARK_GREY, WHITE } from "../../const"

export const StyledSearch = styled.input`
  width: ${props => props.width || "100%"};
  height: 50px;
  line-height: 22px;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid ${LIGHT_GREY};
  padding: 15px;
  background-image: url(${props => props.icon});
  background-color: ${WHITE};
  background-repeat: no-repeat;
  background-position: 95% 12px;
  margin-bottom: 48px;
  color: #4d4d4d;

  &::placeholder {
    font-size: 16px;
    color: ${DARK_GREY};
    opacity: 0.5;
  }

  &:focus {
    outline: none;
    background-image: url(${props => props.icon});
    &::placeholder {
      color: transparent;
    }
  }      
`;

